import AnalyticsPage from './analyticsPage';

export default AnalyticsPage;
